import {
  Typography,
  Paper,
  Switches,
  CardHeader,
  IconAvatar,
  LayersOutlinedIcon,
} from '@occc-app/design-system';

type VoucherStackingProps = {
  disabled: boolean;
};

export const VoucherStacking = ({ disabled }: VoucherStackingProps) => (
  <Paper>
    <CardHeader
      title={
        <Typography variant='subtitle1' gutterBottom>
          Voucher Stacking
        </Typography>
      }
      subheader={
        <Typography variant='body2' color='textSecondary'>
          Allow multiple vouchers for this offer to stack with each other.
        </Typography>
      }
      action={<Switches name='voucherStackingConstraint.isEnabled' data={{ disabled }} />}
      avatar={<IconAvatar Icon={LayersOutlinedIcon} />}
      sx={{ py: 2, px: 3 }}
    />
  </Paper>
);
